export default __webpack_public_path__ + "static/feature-entries-4cbadf868a58aa154cd5e3e2a3d5e4e9.png";